module.exports = __webpack_public_path__ + "img/prize-03.3cc9f6e4.png";